export const CONNECTED_REQUESTS_MASS_EDIT_DEADLINE_FIELD_TEXT_KEYS = {
  dateLabel: 'ConnectedRequestsMassEdit.DeadlineDateLabelKey',
  datePlaceholder: 'ConnectedRequestsMassEdit.DeadlineDatePlaceholderKey',
  timeLabel: 'ConnectedRequestsMassEdit.DeadlineTimeLabelKey',
  timePlaceholder: 'ConnectedRequestsMassEdit.DeadlineTimePlaceholderKey',
}
